import _ from "lodash";

// Give each call the result of the invocation it schedules, including a trailing call.
export const throttlePromiseFunction = (fn, time = 1000) => {
  let waiting = [];

  const run = async (...args) => {
    const callers = waiting;
    waiting = [];

    try {
      const result = await fn(...args);
      callers.forEach(({ resolve }) => resolve(result));
    } catch (error) {
      callers.forEach(({ reject }) => reject(error));
    }
  };

  const throttled = _.throttle(run, time, { leading: true, trailing: true });

  return (...args) =>
    new Promise((resolve, reject) => {
      waiting.push({ resolve, reject });
      throttled(...args);
    });
};
